import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';
import { IEecsAccount, IEecsGoAccount } from 'types';

import { EGrexCountry, IGrexAccounts, IGrexGoAccounts } from '../types/grex.types';

export interface InitialState extends BaseDataReducerV2InitialState<any> {
  accounts: IGrexAccounts;
  firstAccount: IEecsAccount | null;
  goAccounts: IGrexGoAccounts;
}

const { initialState, AC, reducer } = basedDataReducerV2<any, InitialState>('grex-accounts');

const grexInitialState: InitialState = {
  ...initialState,
  firstAccount: null,
  accounts: { DK: null },
  goAccounts: { DK: [] },
};

export const grexAccounts = createSlice({
  name: 'grexAccounts',
  initialState: grexInitialState,
  reducers: {
    setAccounts: (state, action: PayloadAction<IGrexAccounts>) => {
      state.accounts = action.payload;
      state.firstAccount = Object.values(action.payload).find((account) => account) || null;
    },
    updateAccount: (state, action: PayloadAction<{ country: EGrexCountry; account: IEecsAccount | null }>) => {
      state.accounts = { ...state.accounts, [action.payload.country]: action.payload.account };
      state.firstAccount = Object.values(state.accounts).find((account) => account) || null;
    },
    setGoAccounts: (state, action: PayloadAction<{ country: EGrexCountry; goAccounts: IEecsGoAccount[] }>) => {
      state.goAccounts = { ...state.goAccounts, [action.payload.country]: action.payload.goAccounts };
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as InitialState, action);
    });
  },
});
export const GrexAC = AC;

export const { setAccounts: setGrexAccounts, updateAccount, setGoAccounts } = grexAccounts.actions;
